import addAgencyIdAndExecuteFinishToRender from 'utils/addAgencyIdAndExecuteFinishToRender'
import showAgentsAvailable from 'pug/mixins/header/consumer/agentsAvailability'
import getPlanAsURL from 'core/controllerPlans/getPlanAsURL'
import registryListenersDOM from './registryListenersDOM'
import { DETAILS, START_APPLICATION } from 'sites/routes'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import { EPIC, QUANTUM } from 'core/constants/products'
import toggleClass from 'utils/DOM/toggleClass'
import store from 'utils/store/withMiddleware'
import loadQuestions from './loadQuestions'
import getNextStep from './getNextStep'
import getById from 'utils/DOM/getById'
import forEach from 'utils/DOM/forEach'
import getHealthSherpaQuotes from 'core/services/getHealthSherpaQuotes'
import isFixedPlan from 'utils/pivot/plan/isFixedPlan'
import config from './config'
import setOOCDisclaimer from 'pug/mixins/disclaimer/fbmOOC'
import { IS_AGENT, IS_ENROLL, IS_SHORT_TERM } from 'core/constants/environment'
import { sendAddOnsViewEvent } from 'core/services/email/blueshift/implementations/add-ons'
import { updateSessionContext } from 'core/services/updateApplicantContext'
import { redirectToSTM } from 'core/controllerPlansBTM/forbidBTM'
import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import getProduct from 'utils/pivot/eligibility/getProduct'
import getCommissionDisclosureLink from 'sites/pivothealth.com/short-term-health-insurance/consumer/start-application/utils/getCommissionDisclosureLink'
import registerSnowplowListeners from './registerSnowplowListeners'
import isClicPlan from 'utils/pivot/plan/isClicPlan'
import isSureCarePlan from 'utils/pivot/plan/isSureCarePlan'
import initForumBanner from 'pug/mixins/forumBanner/controller'

function initDOM(state) {
  const hcStorage = state.hcStorage
  const smartlySDK = window.hc.smartlySDK
  let disableBTM = 1

  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })

  if (smartlySDK) {
    disableBTM = smartlySDK.treatment('PH_BTM_REDIRECT')
    smartlySDK.track('ph_display_eligibility')
    smartlySDK.publish()
  }

  const plan = state.plans[state.planId]

  redirectToSTM(isBTMPlan(plan), disableBTM)

  const linkProgressBar = document.querySelector('.ProgressBar__link[data-step="3"]')
  const planURL = getPlanAsURL(state)
  const url = document.referrer.indexOf('details') !== -1 ? DETAILS : START_APPLICATION
  linkProgressBar.setAttribute('href', `${url}?${planURL}`)
  forEach('.add-plan', node => {
    node.href += planURL
  })

  const sherpaLinkEl = document.querySelector<HTMLAnchorElement>('#sherpa-link')
  const sherpaLinkRedirect = getHealthSherpaQuotes(hcStorage)
  sherpaLinkEl.href = sherpaLinkRedirect

  updateSessionContext(state.hcStorage, config)
  if (IS_AGENT) {
    sendAddOnsViewEvent()
  }

  toggleClass('.disclaimer__dental', 'd-none', !state.dentalPlanId)
  toggleClass('.disclaimer__latitude', 'd-none', !state.latitudeId)
  toggleClass(
    document.body,
    'quantum-louisiana',
    plan.productId === QUANTUM && hcStorage.location.state_acronym === 'LA'
  )

  toggleClass(
    document.body,
    'epic-pennsylvania',
    plan.productId === EPIC && hcStorage.location.state_acronym === 'PA'
  )

  showAgentsAvailable(hcStorage.location.state_acronym)

  const isEpic = isEpicPlan(plan)
  const isClic = isClicPlan(plan)
  const isSureCare = isSureCarePlan(plan)

  initForumBanner(hcStorage, isClic)
  toggleClass(document.body, 'nric', isEpic)
  toggleClass(document.body, 'clic', isClic)
  toggleClass(document.body, 'sure_care', isSureCare)

  const isFBM = isFixedPlan(plan)
  const product = getProduct(state, config, IS_ENROLL)
  loadQuestions(state, product).then(([questions, enrollData, controller]) => {
    const button = getById<HTMLAnchorElement>('submit')
    button.href = `${getNextStep(isFBM ? undefined : enrollData, state)}?${planURL}`

    store.update({
      questions,
      answersPivot: {}
    })

    if (isFBM) {
      toggleClass(document.body, 'fbm', true)
      setOOCDisclaimer(hcStorage.location.state_acronym)
    }

    registryListenersDOM(controller)
    addAgencyIdAndExecuteFinishToRender()
  })

  if (IS_ENROLL) {
    toggleClass(document.body, 'dtc-eligibility', true)
  }

  if (IS_SHORT_TERM) {
    const commissionDisclosureLink = getCommissionDisclosureLink(plan.planId)

    forEach('.link-commission-disclosure', node => {
      node.href = commissionDisclosureLink
    })
    toggleClass('.limitation-exclusions-footer', 'd-block', true)
    toggleClass('.aca-commission-disclosure', 'd-block', !isEpic)
  }

  registerSnowplowListeners()
}

export default initDOM
